import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  useNavigate,
  useLocation,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { Title } from 'react-admin';
import { LAYOUT } from '../../../theme';
import { ModelPresetsSettings } from './ModelPresetsSettings';
import { ContentGenSettings } from './ContentGenSettings';
import { AutomationsSettings } from './AutomationsSettings';
import { CleanupSettings } from './CleanupSettings';
import { RemoteConfigSettings } from './RemoteConfigSettings';
import { InsertsSettings } from './InsertsSettings';

export const Settings: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine current tab based on URL
  const getTabValue = () => {
    if (location.pathname.includes('/automations')) {
      return 0;
    } else if (location.pathname.includes('/model-presets')) {
      return 1;
    } else if (location.pathname.includes('/content-gen')) {
      return 2;
    } else if (location.pathname.includes('/cleanup')) {
      return 3;
    } else if (location.pathname.includes('/remote-config')) {
      return 4;
    } else if (location.pathname.includes('/inserts')) {
      return 5;
    }
    return 0; // Default to automations
  };

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/settings/automations');
        break;
      case 1:
        navigate('/settings/model-presets');
        break;
      case 2:
        navigate('/settings/content-gen');
        break;
      case 3:
        navigate('/settings/cleanup');
        break;
      case 4:
        navigate('/settings/remote-config');
        break;
      case 5:
        navigate('/settings/inserts');
        break;
      default:
        navigate('/settings/automations');
        break;
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: LAYOUT.settingsMaxWidth,
          margin: '0 auto',
        }}
      >
        <Title title="Settings" />

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={getTabValue()} onChange={handleTabChange}>
            <Tab label="Automations" />
            <Tab label="Model Presets" />
            <Tab label="Content Gen" />
            <Tab label="Cleanup" />
            <Tab label="Remote Config" />
            <Tab label="Inserts" />
          </Tabs>
        </Box>

        <Routes>
          <Route path="automations" element={<AutomationsSettings />} />
          <Route path="model-presets" element={<ModelPresetsSettings />} />
          <Route path="content-gen" element={<ContentGenSettings />} />
          <Route path="cleanup" element={<CleanupSettings />} />
          <Route path="remote-config" element={<RemoteConfigSettings />} />
          <Route path="inserts" element={<InsertsSettings />} />
          <Route
            path="/"
            element={<Navigate to="/settings/automations" replace />}
          />
        </Routes>
      </Box>
    </Box>
  );
};
